import NotificationComponent from "./NotificationComponent.vue";

export { NotificationComponent };
